import { Link } from "react-router-dom";
import { MapPin, Phone, Clock, Facebook, Instagram } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_10d419fc-5e2e-447b-b30b-f3a6e5d925a0/artifacts/qt2o5wzu_file_0000000029f471f48789e22e477ba51d.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary text-primary-foreground">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <img 
                src={LOGO_URL} 
                alt="Bacon & Brews" 
                className="h-20 w-auto object-contain brightness-110"
              />
            </Link>
            <p className="text-primary-foreground/80 text-sm leading-relaxed">
              Proper bacon sandwiches and freshly brewed tea. 
              Fast, honest, filling. No fuss.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-display text-lg font-semibold mb-4 text-wheat">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {[
                { href: "/", label: "Home" },
                { href: "/menu", label: "Our Menu" },
                { href: "/about", label: "About Us" },
                { href: "/contact", label: "Contact" },
                { href: "/order", label: "Order Now" },
              ].map((link) => (
                <li key={link.href}>
                  <Link 
                    to={link.href}
                    className="text-primary-foreground/80 hover:text-wheat transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-display text-lg font-semibold mb-4 text-wheat">
              Find Us
            </h4>
            <ul className="space-y-4">
              <li className="flex gap-3">
                <MapPin className="h-5 w-5 text-wheat shrink-0 mt-0.5" />
                <span className="text-primary-foreground/80 text-sm">
                  59 Torquay Road<br />
                  Paignton, Devon<br />
                  TQ3 3DT
                </span>
              </li>
              <li>
                <a 
                  href="tel:+447424864732"
                  className="flex items-center gap-3 text-primary-foreground/80 hover:text-wheat transition-colors"
                >
                  <Phone className="h-5 w-5 text-wheat" />
                  <span className="text-sm">07424 864732</span>
                </a>
              </li>
            </ul>
          </div>

          {/* Opening Hours */}
          <div>
            <h4 className="font-display text-lg font-semibold mb-4 text-wheat">
              Opening Hours
            </h4>
            <div className="flex items-start gap-3 mb-4">
              <Clock className="h-5 w-5 text-wheat shrink-0 mt-0.5" />
              <div className="text-sm text-primary-foreground/80">
                <p className="font-medium text-primary-foreground mb-1">Every Day</p>
                <p>8:00 AM – 12:00 PM</p>
              </div>
            </div>
            
            {/* Social Links */}
            <div className="mt-6">
              <p className="text-sm font-medium text-primary-foreground mb-3">Follow Us</p>
              <div className="flex gap-3">
                <a 
                  href="#" 
                  className="w-10 h-10 rounded-full bg-primary-foreground/10 flex items-center justify-center hover:bg-wheat hover:text-primary transition-colors"
                  aria-label="Facebook"
                >
                  <Facebook className="h-5 w-5" />
                </a>
                <a 
                  href="#" 
                  className="w-10 h-10 rounded-full bg-primary-foreground/10 flex items-center justify-center hover:bg-wheat hover:text-primary transition-colors"
                  aria-label="Instagram"
                >
                  <Instagram className="h-5 w-5" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-primary-foreground/10">
        <div className="container mx-auto px-4 py-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-primary-foreground/60">
            <p>© {currentYear} Bacon & Brews. All rights reserved.</p>
            <p className="font-display italic">"Proper Bacon. Proper Brew."</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
